export default __webpack_public_path__ + "static/media/image.ingenii-lanka-pvt-ltd.4978dadc.png";